import { HugeiconsIcon } from "@hugeicons/react";
import { Alert02Icon } from "@hugeicons-pro/core-stroke-rounded";
import { Badge, BadgeSize, BadgeVariant } from "shared/components";
import type { UnitAccessMethod } from "types/landlord/address";
import { useUnitsPropertiesDictionary } from "shared/hooks/use-units-properties";

export const LOCKBOX_BADGE_TOOLTIP_CLASS = "z-[102] !bg-content-1000";

const badgeCopy = (
  accessMethod: UnitAccessMethod,
  unit: string
): { label: string; tooltip: string } =>
  accessMethod === "entry_instructions"
    ? {
        label: "Needs entry instructions",
        tooltip: `This ${unit} has no entry instructions. Leads who book a self-guided showing won't receive any access details.`
      }
    : {
        label: "Needs lockbox",
        tooltip: `This ${unit} is available for self-guided showings but has no lockbox linked.`
      };

export const NeedsLockboxBadge = ({
  className,
  accessMethod = "lockbox"
}: {
  className?: string;
  accessMethod?: UnitAccessMethod;
}) => {
  const { unit } = useUnitsPropertiesDictionary();
  const copy = badgeCopy(accessMethod, unit);

  return (
    <Badge
      variant={BadgeVariant.WARNING}
      size={BadgeSize.SM}
      className={className}
      leftElement={
        <HugeiconsIcon icon={Alert02Icon} size={14} className="shrink-0" />
      }
      tooltip={copy.tooltip}
      tooltipClassName={LOCKBOX_BADGE_TOOLTIP_CLASS}
      placement="bottom"
    >
      {copy.label}
    </Badge>
  );
};
